import {
  Link as RouterLink,
  useNavigation,
  type LinkProps as RouterLinkProps,
} from "react-router-dom";
import type { ReactNode } from "react";

export type NextLinkProps = Omit<RouterLinkProps, "to" | "prefetch"> & {
  href: string;
  children?: ReactNode;
  /** Next.js boolean prefetch maps to React Router `"intent"` when true. */
  prefetch?: boolean | RouterLinkProps["prefetch"];
  /** Next.js `<Link scroll={false}>` — ignored in SPA (no built-in scroll control). */
  scroll?: boolean;
};

/**
 * Maps Next.js `<Link href>` to React Router `<Link to>`.
 */
export default function Link({ href, prefetch, scroll: _scroll, ...rest }: NextLinkProps) {
  const rrPrefetch: RouterLinkProps["prefetch"] =
    prefetch === true
      ? "intent"
      : prefetch === false || prefetch === undefined
        ? undefined
        : prefetch;

  return <RouterLink to={href} prefetch={rrPrefetch} {...rest} />;
}

/** Approximates Next.js `useLinkStatus` using React Router navigation state. */
export function useLinkStatus(): { pending: boolean } {
  const navigation = useNavigation();
  return { pending: navigation.state === "loading" };
}

export type { LinkProps } from "react-router-dom";
